<div class="p-6" data-element="publish-dialog-container">
  <!-- Limited preview  -->
  <ng-container *ngIf="limitedPreview$ | async; else regularContent">
    <div class="flex justify-between items-center mb-4" data-element="publish-dialog-header">
      <h3 class="text-xl font-semibold m-0">Upgrade to Mogul to Publish</h3>
      <sbnb-close (click)="dialogRef.close()" data-element="publish-dialog-close"></sbnb-close>
    </div>
    <ng-container *ngIf="isPrimaryUser$ | async; else genericCTA">
      <div class="flex flex-col gap-4" data-element="upgrade-prompt">
        <p class="text-night">
          Save countless hours by automating Owner Statements for all of your properties. Book a call with our Customer
          Success team to get started today!
        </p>
        <div class="flex justify-between mt-4">
          <ng-container *ngTemplateOutlet="nevermindButton"></ng-container>
          <div class="flex flex-end gap-4 items-center">
            <sbnb-button
              type="text"
              label="Or schedule a call!"
              (click)="dialogRef.close('upgrade')"
              data-element="upgrade-button"></sbnb-button>
            <sbnb-button label="Upgrade subscription" [routerLink]="['/settings/your-plan']"></sbnb-button>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #genericCTA>
      <div *ngIf="viewModel$ | async as vm" class="flex flex-col gap-4" data-element="upgrade-prompt">
        <p class="text-night">
          {{ vm.type | humanize }} can only be published after your account has been upgraded to Mogul.
        </p>
        <div class="flex justify-end mt-4">
          <ng-container *ngTemplateOutlet="nevermindButton"></ng-container>
        </div>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #regularContent>
    <ng-container *ngIf="viewModel$ | async as vm">
      <div class="flex justify-between items-center mb-4" data-element="publish-dialog-header">
        <h3 *ngIf="!(vm.accountingConnectionUpsell && !quickbooksNotRightNow)" class="text-xl font-semibold m-0">
          Publish this {{ vm.type }}?
        </h3>
        <h3 *ngIf="vm.accountingConnectionUpsell && !quickbooksNotRightNow" class="text-xl font-semibold m-0">
          Connect your accounting software
        </h3>
        <sbnb-close (click)="dialogRef.close()" data-element="publish-dialog-close"></sbnb-close>
      </div>

      <!-- Accounting upsell before publish warning -->
      <ng-container *ngIf="vm.accountingConnectionUpsell && !quickbooksNotRightNow">
        <div class="flex flex-col gap-4" data-element="publish-dialog-content">
          <p class="text-night m-0">
            Don't worry about entering this manually into your accounting software. We'll take care of that for you
            automatically, each time you publish {{ vm?.isInvoice ? 'an invoice' : 'a statement' }}.
          </p>
          <div class="flex justify-between mt-4">
            <sbnb-button
              type="secondary"
              label="Not right now"
              (click)="onDismissQuickbooksUpsell()"
              data-element="dismiss-quickbooks-upsell"></sbnb-button>
            <sbnb-button
              label="Connect Quickbooks"
              (click)="onConnectQuickbooks()"
              data-element="connect-quickbooks-button"></sbnb-button>
          </div>
        </div>
      </ng-container>

      <!-- Accounting disabled or dismissed upsell - Show regular warning -->
      <ng-container *ngIf="(!vm.accountingEnabled && !vm.accountingConnectionUpsell) || quickbooksNotRightNow">
        <div class="flex flex-col gap-4" data-element="publish-dialog-content">
          <p class="text-night m-0">
            Publishing {{ vm?.isInvoice ? 'an invoice' : 'a statement' }} locks the reservation and transaction data on
            that {{ vm.type }}.
          </p>
          <p class="text-night m-0">
            Any reservation alterations that happen on reservations that are already locked will be accounted for on the
            next available open {{ vm.type }}.
          </p>
          <div class="flex justify-between mt-4">
            <ng-container *ngTemplateOutlet="nevermindButton"></ng-container>
            <sbnb-button
              label="Publish"
              (click)="dialogRef.close('publish')"
              data-element="confirm-publish-button"></sbnb-button>
          </div>
        </div>
      </ng-container>

      <!-- Accounting enabled -->
      <ng-container *ngIf="vm.accountingEnabled">
        <div class="flex flex-col gap-4" data-element="publish-dialog-content">
          <p class="text-night m-0">
            Publishing {{ vm?.isInvoice ? 'an invoice' : 'a statement' }} locks the reservation and transaction data on
            that {{ vm.type }} and pushes it to your accounting software.
          </p>
          <ul *ngIf="!vm.isInvoice" class="list">
            <li>
              Reservation financials will be created in your accounting software as Journals in the Accounts mapped in
              your Chart of Accounts, and according to your Reservation commission.
            </li>
            <li>Guests will be created in your accounting software as Customers.</li>
            <li>Transactions will be pushed to your accounting software as Expenses.</li>
          </ul>

          <ul *ngIf="vm.isInvoice" class="list">
            <li>
              The total amount owed to you will be pushed to your accounting software as Journals in the Accounts mapped
              in your Chart of Accounts, and according to your Reservation commission.
            </li>
            <li>Transactions will be pushed to your accounting software as Expenses.</li>
          </ul>
          <p class="text-night m-0">
            Any reservation alterations that happen on reservations that are already locked will be accounted for on the
            next available open {{ vm.type }}.
          </p>
          <div class="flex justify-between mt-4">
            <ng-container *ngTemplateOutlet="nevermindButton"></ng-container>
            <sbnb-button
              label="Publish"
              (click)="dialogRef.close('publish')"
              data-element="confirm-publish-button"></sbnb-button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>
</div>

<ng-template #nevermindButton>
  <sbnb-button
    type="secondary"
    label="Cancel"
    (click)="dialogRef.close()"
    data-element="cancel-publish-button"></sbnb-button>
</ng-template>
